import * as guidelines from "style/guidelines";
import * as colors from "style/colors";
import * as editor from "style/editor";
import * as devices from "style/devices";
import * as mixins from "style/mixins";

const colorsDark = {
    ...colors,
    text1: colors.text3,
    text2: colors.text3,
    text3: colors.secondaryDark,
    text8: colors.text3,
    text11: colors.text3,
    primaryIcon: `#fff`,
    primaryBackground: `#35425c`,
    primaryBorder: `#2c3143`,
    outline: `#2c3143`,
    lightOutline: `#e8e8e8`,
    primaryText: `#f0f0f0`,
    defaultText: `#C9DAF8`,
    secondaryText: colors.secondaryLighter,
    headingText: `#DDE2FF`,
    cardBackground: `#36425c`,
    cardBoxShadow: `0px 6px 12px rgba(54, 66, 92, 0.3)`,
    cardBoxShadowHover: `0px 6px 12px rgba(54, 66, 92, 0.5)`,
    tabbedIcon: `#fff`,
    tabbedNavBackground: `#35425c`,
    tabbedItemBackground: `#35425c`,
    tertiaryBackground: `#2C3144`,
    sidebarHeaderColour: `#fff`,
    assetBodyBackground: `#596281`,
    secondaryBorder: `#fff`,
    illustrationText: `#7E8BB5`,
    button: {
        disabledBg: `#2C3144`,
        disabledBorder: `#596281`,
        disabledText: `#596281`
    },
    gradient: {
        processing: `linear-gradient(to right, #8c5b0a 35%, #ff9f02 50%, #8c5b0a 65%)`
    },
    secondaryBackground: `#2C3144`,
    textDisabled: `#596281`,
    contextMenuItem: {
        border: `#596281`,
        hoverBackground: `#596281`,
        text: `#fff`
    },
    contextMenu: {
        border: `transparent`,
        boxShadow: `0px 0px 8px 2px rgb(0 0 0 / 25%)`
    },
    toggleSwitch: `#7E8BB5`,
    toolbarOverlay: `rgba(89, 98, 129, 0.8)`,
    producerBodyBackground: `#35425c`,
    headerBackground: `#2C3144`,
    dropdownBackground: `#262F3F`,
    headerDropdownText: colors.defaultText,
    headerBottomBorder: `rgb(22, 24, 34, 0.25)`,
    preferencesIconFocusColor: colors.primaryButtonText,
    timeDisplayText: colors.text3,
    background: `#2c3144`,
    playerControls: `#fff`,
    primaryLabel: `#B2B9D3`,
    inputText: `#B2B9D3`,
    inputOutline: `#1A1F2A`,
    textPlaceholder: `#596281`,
    text7: `#7E8BB5`
};

const theme = {
    mode: `light`,
    ...guidelines,
    ...editor,
    colors,
    ...devices,
    mixins
};

export const darkTheme: ThemeType = {
    mode: `dark`,
    ...guidelines,
    ...editor,
    colors: colorsDark as ThemeType["colors"], // We need to type this explicityly otherwise it will try to match the constant string values
    ...devices,
    mixins
};

export default theme;

type tt = typeof theme;
export interface ThemeType extends tt {}
